import { FC, Fragment } from 'react'
import { Navigate, useParams } from 'react-router-dom'

import { PageTransition } from 'utils/animations'
import { Path } from 'constants/router'
import { PropertyTab } from '../contexts'
import { VisualsEditingContextProvider } from 'components/pages/VisualsEditing/VisualsEditing.context'
import { VisualsEditingController } from 'components/pages/VisualsEditing'
import { VisualsEditingDownloadProvider } from 'components/pages/VisualsEditing/VisualsEditingDownload.context'
import { WorkspacesProfileContextProvider } from 'components/pages/Client/WorkspacesProfile/_main/WorkspacesProfile.context'
import { useUserData } from 'components/contexts/UserDataContext'

/**
 * @interface Props for the ClientPropertyGalleryExportOptionsFlowPage page.
 */
interface Props {
  /** Selected visuals */
  selectedVisuals: Set<string>
}

export const ClientPropertyGalleryExportOptionsFlowPage: FC<Props> = ({ selectedVisuals }) => {
  const { id = '', assignmentId = '' } = useParams<{ id: string, assignmentId: string }>()
  const { currentUserWorkspace } = useUserData()

  return (
    <Fragment>
      {!!selectedVisuals.size ?
        <WorkspacesProfileContextProvider workspaceId={currentUserWorkspace?.id ?? ''}>
          <VisualsEditingDownloadProvider assignmentId={assignmentId}>
            <VisualsEditingContextProvider assignmentId={assignmentId} selected={selectedVisuals}>
              <PageTransition>
                <VisualsEditingController />
              </PageTransition>
            </VisualsEditingContextProvider>
          </VisualsEditingDownloadProvider>
        </WorkspacesProfileContextProvider>
        :
        <Navigate to={Path.PROPERTY_TAB_ASSIGNMENT.replace(':id', id.toString()).replace(':tab', PropertyTab.GALLERY).replace(':assignmentId', assignmentId)} />
      }
    </Fragment>
  )
}
